import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ff-text-buttons',
  templateUrl: './text-buttons.component.html',
  styleUrls: ['./text-buttons.component.scss']
})
export class TextButtonsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
